import { Container, Stack } from '@mui/material';
import React from 'react';
import { Box } from '@mui/system';

function ApplicationFooter() {
  return (
    <Box className="footer">
      <Container
        sx={{
          fontSize: '14px'
        }}
      >
        <Stack>Copyright © 2022. All rights reserved.</Stack>
      </Container>
    </Box>
  );
}
export default ApplicationFooter;
